import packageJson from '../../package.json'

export interface VersionInfo {
    major: number
    minor: number
    patch: number
    build: number
    full: string
}

export const getVersion = (): VersionInfo => {
    const version = packageJson.version
    
    // Parse version format: MAJOR.MINOR.PATCH+BUILD or MAJOR.MINOR.PATCH
    const [baseVersion, buildStr] = version.split('+')
    const [major, minor, patch] = baseVersion.split('.').map(Number)
    const build = buildStr ? parseInt(buildStr, 10) : 0
    
    return {
        major,
        minor,
        patch,
        build,
        full: build > 0 ? `${major}.${minor}.${patch}+${build}` : `${major}.${minor}.${patch}`,
    }
}

export const formatVersionForDisplay = (includePrefix = true): string => {
    const version = getVersion()
    const versionStr = version.full
    return includePrefix ? `v${versionStr}` : versionStr
}